import { z } from "zod";
import { CollectNodeFieldTypeEnum } from "../../../../enum/nodes.enum";

export const collectNodeNumberFieldSchema = z.object({
  type: z.literal(CollectNodeFieldTypeEnum.NUMBER),
  minValue: z
    .string()
    .refine((v) => {
      return !Number.isNaN(Number(v));
    }, "Please enter valid number")
    .optional(),
  maxValue: z
    .string()
    .refine((v) => {
      return !Number.isNaN(Number(v));
    }, "Please enter valid number")
    .optional(),
  allowDecimal: z.boolean().default(false).optional(),
});
